module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/symbol-apple_d242315.png";